/**
 * Reads GET /api/quality-copilot/desk once per door visit. A failure (or an
 * older backend without the endpoint) leaves it null: the door then shows
 * the viewer's own queue, as before.
 */
import { useEffect, useState } from 'react';
import { getDoorDesk, type DoorDeskRead } from '../../services/qcpDesk';

export function useDoorDesk(enabled: boolean): DoorDeskRead | null {
  const [desk, setDesk] = useState<DoorDeskRead | null>(null);
  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    getDoorDesk()
      .then((d) => {
        if (!cancelled) setDesk(d);
      })
      .catch(() => {
        if (!cancelled) setDesk(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return desk;
}
